/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-01-14 18:39:25
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-10-23 10:32:53
 * @FilePath: \vue-hepha-order\src\views\dealerPreOrder\queryConfig\B2BShopOrderListQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const DealerOpenOrderListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'order.customerType', // 订单类型
            key:'order_channel_type',
            type:'select',   
            allowClear:false,
            width:'200px',
            placeholder:'order.orderChannelType',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
                {
                    value:5,
                    label:'order.c2c'
                },
            ]
        },
        {
            // name:'dealerOpenOrder.orderNumber', // 订单号
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'dealerOpenOrder.orderNumber',
        },
        {
            // name:'dealerOpenOrder.customerNumber', // 客户/经销商编码
            key:'customer_number',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'dealerOpenOrder.customerNumber',
        },
        {
            // name:'dealerOpenOrder.orderChannelType', // 渠道（文本）
            key:'customer_name',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealerOpenOrder.orderChannelType',
            optionToLocale:true,
            options:[]
        },
        {
            // name:'dealerOpenOrder.erpSoNo', // ERP SO No.
            key:'erp_so_no',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'dealerOpenOrder.erpSoNo',
        },
        {
            // name:'dealerOpenOrder.orderStatus', // 订单状态
            key:'order_status_int',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder:'dealerOpenOrder.orderStatus',
            optionToLocale:true,
            options:[
                { value:-1, label:'order.finalPayment' },
                { value:0, label:'order.partialPay' },
                { value:1, label:'order.pay' },
                { value:2, label:'order.refund' },
                { value:4, label:'order.partialRefund' },
                { value:6, label:'order.canceled' },
                { value:7, label:'order.obligation' },
            ]
        },
        {
            // name:'dealerOpenOrder.shipmentStatus', // 发货状态
            key:'shipment_status_int',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder:'dealerOpenOrder.shipmentStatus',
            optionToLocale:true,
            options:[
                { value:0, label:'order.unship' },
                { value:1, label:'order.plan' },
                { value:2, label:'order.partialShip' },
                { value:3, label:'order.shiped' },
                { value:4, label:'order.signedFor' },
                { value:5, label:'order.cancel' },
                { value:7, label:'order.partialReturn' },
                { value:8, label:'order.return' },
                { value:9, label:'order.exchange' },
                { value:10, label:'order.partialExchange' },
                { value:99, label:'order.noNeedToShip' },
            ]
        },
        {
            // name:'dealerOpenOrder.categoryCode', // 类型
            key:'category_code',
            type:'select',
            allowClear:true,
            width:'150px',
            placeholder:'dealerOpenOrder.categoryCode',
            optionToLocale:true,
            options:[
                { value:'627.501', label:'dealerOpenOrder.bike' },
                { value:'000.000', label:'dealerOpenOrder.parts' },
            ]
        },
        {
            // name:'dealerOpenOrder.sku', // SKU
            key:'sku',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'dealerOpenOrder.sku',
            // options:[]
        },
        {
            // name:'inventoryLock.inventoryType', // 锁定类型
            key:'inventory_type',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder:'inventoryLock.inventoryType',
            optionToLocale:true,
            options:[
                { value:'in_stock', label:'inventoryLock.inStock' },
                { value:'in_transit', label:'inventoryLock.inTransit' },
                { value:'production_plan', label:'inventoryLock.productionPlan' },
            ]
        },
        {
            // name:'customer.customerCity', // 订单日期
            key:'order_date',
            type:'dateRange',   
            allowClear:true,
            showTime:false,
            width:'250px',
            placeholder:'order.order_timestamp',
        },
        {
            // name:'customer.customerCity', // 预计交期日期
            key:'plan_ship_date',
            type:'dateRange',   
            allowClear:true,
            showTime:false,
            show: true,
            width:'350px',
            placeholder1:'dealerOpenOrder.plan_start_timestamp',
            placeholder2:'dealerOpenOrder.plan_end_timestamp',
        },
    ]
}

// 发货申请
const DeliverForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    formData:{},
    formField:[
        {
            name:'order.courierType',// 物流公司
            key:'courier_type',
            type:'select',
            allowClear:true,
            required: false,
            width:'450px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'order.courierNo',//物流单号
            key:'courier_no',
            type:'input',   
            allowClear:true,
            required: false,
            disabled:false,
            width:'450px',
            placeholder:'base.input',
        },
        {
            name:'order.courierLink',//物流链接
            key:'courier_url',
            type:'input',   
            allowClear:true,
            required: false,
            disabled:false,
            width:'450px',
            placeholder:'base.input',
        },
    ]
}

DealerOpenOrderListQuery.formField.forEach(item=>{
    DealerOpenOrderListQuery.formData[item.key] = ''
})

DeliverForm.formField.forEach(item=>{
    DeliverForm.formData[item.key] = ''
})

export {
    DealerOpenOrderListQuery,
    DeliverForm,
}